import React from 'react'
import TopBar from './layouts/TopBar'
import Header from './layouts/Header'
import SocialRow from './layouts/SocialRow'
import IconRow from './layouts/IconRow'
import Footer from './layouts/Footer'
import {Container,Row,Col,Button} from 'react-bootstrap'
import { FaAngleLeft } from 'react-icons/fa';
import CircumstanceB from './assets/icons/CircumstanceB';
import { Link, useHistory } from "react-router-dom";

import C1 from './assets/icons/C1';
import C2 from './assets/icons/C2';
import C3 from './assets/icons/C3';
import C4 from './assets/icons/C4';
import C5 from './assets/icons/C5';
import C6 from './assets/icons/C6';
import C7 from './assets/icons/C7';
import C8 from './assets/icons/C8';
import C9 from './assets/icons/C9';
import C10 from './assets/icons/C10';
import C11 from './assets/icons/C11';
import C12 from './assets/icons/C12';
import C13 from './assets/icons/C13';
import C14 from './assets/icons/C14';
import C15 from './assets/icons/C15';
import C16 from './assets/icons/C16';
import C17 from './assets/icons/C17';
import C18 from './assets/icons/C18';
import C19 from './assets/icons/C19';
import C20 from './assets/icons/C20';
import C21 from './assets/icons/C21';
import C22 from './assets/icons/C22';
const Circumstance = () => {
  return (
    <>
      <TopBar/>
      <Header/>
    <Container fluid className="bulbiranContainer">
    <div className="whiteBox pdc">
        <Row>
            <Col md={8}>
                <h3 className="brandShopTitle">روشنایی متناسب با محیط</h3>
                <p className="brandShopDescription">
                بازار روشنایی ایران شامل برندهای موجود در ایران اعم از تولید داخل یا خارج می باشد که هرکدام مزایا و معایب خاص خود را دارا هستند.
<br></br>
تولیدات گوناگون و سبدهای کالایی رنگارنگی در این بازار وجود دارد که بر اساس سازنده آن طبقه بندی شده است.
<br></br>
بازار روشنایی ایران شامل برندهای موجود در ایران اعم از تولید داخل یا خارج می باشد که هرکدام مزایا و معایب خاص خود را دارا هستند.
<br></br>
تولیدات گوناگون و سبدهای کالایی رنگارنگی در این بازار وجود دارد که بر اساس سازنده آن طبقه بندی شده است.

                </p>
            </Col>
            <Col md={4}>
            <CircumstanceB className="resW100"/>
            </Col>
        </Row>
    </div>
    <div className="coloredBox" id="circumstanceColoreBox">
        <h3 className="coloredBoxTitle">
           محیط مورد نظر خود را انتخاب کنید
        </h3>
    </div>

    <div className="brandShopBox">
   <Row className="t1">
 
       <Col md={2} xs={4} className="ta-center">
       <Link
          to={`/CircumstanceSecond/4`}
        >
           <div className="cBox">
              <C1/>
               <p>تعمیرگاه</p>
           </div>
       </Link> </Col>
      
      
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/5`}
        >
           <div className="cBox">
              <C2/>
               <p>کسب و کار کوچک</p>
           </div>
              </Link> </Col>
     
   
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/6`}
        >
           <div className="cBox">
              <C3/>
               <p>مذهبی</p>
           </div>
           </Link>
       </Col>
       

     
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/7`}
        >
           <div className="cBox">
              <C4/>
               <p>مراکز درمانی</p>
           </div>
           </Link>
         </Col>
        
   
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/8`}
        >
           <div className="cBox">
              <C5/>
               <p>آموزش</p>
           </div>
           </Link>
         </Col>
      
      
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/9`}
        >
           <div className="cBox">
              <C6/>
               <p>رستوران</p>
           </div>
           </Link></Col>
    
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/10`}
        >
           <div className="cBox">
              <C7/>
               <p>انبار</p>
           </div>
           </Link> </Col>
     
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/11`}
        >
           <div className="cBox">
              <C8/>
               <p>ساخت و ساز</p>
           </div>
           </Link></Col>
    
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/12`}
        >
           <div className="cBox">
              <C9/>
               <p>مشاوره مسکن</p>
           </div>
           </Link> </Col>
      
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/13`}
        >
           <div className="cBox">
              <C10/>
               <p>هتل</p>
           </div>
           </Link></Col>
   
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/14`}
        >
           <div className="cBox">
              <C11/>
               <p>خرده فروشی</p>
           </div>
           </Link></Col>
  
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/15`}
        >
           <div className="cBox">
              <C12/>
               <p>نمای ساختمان</p>
           </div>
           </Link></Col>
       
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/16`}
        >
           <div className="cBox">
              <C13/>
               <p>فروشگاه و پاساژ</p>
           </div>
           </Link>   </Col>
    
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/17`}
        >
           <div className="cBox">
              <C14/>
               <p>اداره</p>
           </div>
           </Link>    </Col>
       
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/18`}
        >
           <div className="cBox">
              <C15/>
               <p>استخر</p>
           </div>
           </Link> </Col>
    
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/19`}
        >
           <div className="cBox">
              <C16/>
               <p>پالایشگاه</p>
           </div>
           </Link></Col>
     
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/20`}
        >
           <div className="cBox">
              <C17/>
               <p>پارک و باغ</p>
           </div>
           </Link> </Col>
      
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/21`}
        >
           <div className="cBox">
              <C18/>
               <p>کارخانه</p>
           </div>
           </Link> </Col>
      
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/22`}
        >
           <div className="cBox">
              <C19/>
               <p>دام و طیور</p>
           </div>
           </Link> </Col>
     
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/23`}
        >
           <div className="cBox">
              <C20/>
               <p>گلخانه</p>
           </div>
           </Link> </Col>
     
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/24`}
        >
           <div className="cBox">
              <C21/>
               <p>تبلیغات</p>
           </div>
           </Link></Col>
     
          <Col md={2} xs={4} className="ta-center">
          <Link
          to={`/CircumstanceSecond/25`}
        >
           <div className="cBox">
              <C22/>
               <p>خیابان</p>
           </div>
           </Link>  </Col>

   </Row>
   </div>
    </Container>
    <SocialRow/>
    <IconRow/>
    <Footer/>
    </>
  );
};
export default Circumstance;
